import { Space, Text } from '@procurify/ui'

import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { useProcurifyIntl } from '@webapp/hooks'
import { type IConversationCheckoutOrderSummaryGroup } from './ConversationCheckoutOrderSummary'
import { ConversationCheckoutOrderSummaryAddresses } from './ConversationCheckoutOrderSummaryAddresses'
import { ConversationCheckoutOrderSummaryPaymentMethod } from './ConversationCheckoutOrderSummaryPaymentMethod'
import {
  ConversationOrderSummaryDelivery,
  type IConversationOrderSummaryDeliveryItem,
} from './ConversationOrderSummaryDelivery'
import { ConversationOrderSummarySource } from './ConversationOrderSummarySource'
import messages from './messages'

export interface IConversationCheckoutOrderSummaryVendorProps {
  group: IConversationCheckoutOrderSummaryGroup
  currency: CurrencyName
  showSource: boolean
  disabled?: boolean
  onSendMessage: (message: string) => void
}

export const ConversationCheckoutOrderSummaryVendor = ({
  group,
  currency,
  showSource,
  disabled,
  onSendMessage,
}: IConversationCheckoutOrderSummaryVendorProps) => {
  const intl = useProcurifyIntl()

  const renderQuantity = (item: IConversationOrderSummaryDeliveryItem) => (
    <Text inline color='textSecondary'>
      {intl.formatMessage(messages.quantityLabel, { quantity: item.quantity })}
    </Text>
  )

  return (
    <Space direction='vertical' size='medium'>
      {showSource && group.vendor && (
        <ConversationOrderSummarySource
          vendor={group.vendor}
          outlined={false}
        />
      )}
      <ConversationCheckoutOrderSummaryAddresses
        shipTo={group.shipTo}
        billTo={group.billTo}
      />
      {group.paymentMethod && (
        <ConversationCheckoutOrderSummaryPaymentMethod
          paymentMethod={group.paymentMethod}
          disabled={disabled}
          onSendMessage={onSendMessage}
        />
      )}
      {group.deliveries.map((delivery, index) => (
        <ConversationOrderSummaryDelivery
          key={delivery.id}
          delivery={delivery}
          position={index + 1}
          currency={currency}
          isCollapsible={false}
          renderQuantity={renderQuantity}
        />
      ))}
    </Space>
  )
}
